<template>
  <div>
    <div class="foot-b">
      <div class="w foot-b-item">
        <ul class="foot-bottom">
          <li>
            <a v-text="common_info.icp"></a>
            <!-- <span v-text="common_info.copyright"
                  v-else></span> -->
          </li>
          <li>
            <a v-text="common_info.isp"></a>
            <!-- <span v-text="common_info.copyright"
                  v-else></span> -->
          </li>
          <!-- <li v-if="common_info.help.copyright.text"
              v-text="common_info.help.copyright.text"></li> -->
          <!-- <li v-if="common_info.help.copyright.phone"
              v-text="'Tel: '+common_info.help.copyright.phone"></li>-->
          <li>
            <a href="https://www.hongyuego.com/#/"
               target="_blank"></a>
            <span>：</span>
            <a href="https://www.hongyuego.com/#/"
               target="_blank">宏樾商城</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['footerhidden'],
  components: {},
  data() {
    return {
      common_info: {},
      // help: {
      //   links: {},
      //   list: {},
      //   right_content: {},
      //   copyright: {}
      // }
      // },
      footer_hidden: true
    }
  },
  created() {
    let that = this
    let params = {
      shop_type: 'qycg'
    }
    that.$api
      .qycgfoot(params)
      .then(res => {
        if (res.code == 0) {
          this.common_info = res.data
          console.log(this.common_info,"this.common_info")
          window.localStorage.setItem('logo', res.data.logo)
          window.localStorage.setItem('qycgTitle',res.data.title)
        }
      })
      .catch(err => {
        console.log(err)
      })

    // this.common.getCommonInfo(this, function() {
    // console.log(that.common_info, '0000')
    /* let statistics_url = that.common_info.help.copyright.statistics_url;
				statistics_url = statistics_url.replace('<script type="text/javascript">','');
				statistics_url = statistics_url.replace(';<\/script>','');
				console.log(statistics_url);
				const script = document.createElement('script');
				script.innerText = statistics_url;
				script.language = 'JavaScript';
				document.getElementById('app').appendChild(script); */
    /* const script = document.createElement('script');
				script.innerText = `document.write(unescape("%3Cspan id='cnzz_stat_icon_1279615811'%3E%3C/span%3E%3Cscript src='http://v1.cnzz.com/z_stat.php%3Fid%3D1279615811%26show%3Dpic' type='text/javascript'%3E%3C/script%3E"));`;
				script.language = 'JavaScript';
				document.getElementById('app').appendChild(script); */
    // })
  },
  mounted() {
    if (this.footerhidden != undefined) {
      this.footer_hidden = this.footerhidden
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.foot-t {
  width: 100%;
  background-color: #f2f2f2;

  .foot-t-item {
    height: 108px;
    display: flex;
    justify-content: space-between;

    li {
      font-size: 20px;
      color: #333333;
      display: flex;
      align-items: center;

      img {
        display: block;
        width: 37px;
        height: 40px;
        margin-right: 19px;
      }
      span {
        font-size: 20px;
      }
    }
  }
}

.foot-c {
  width: 100%;
  border-top: 1px solid #ebebeb;
  // background-color: #fafafa;
  padding: 40px 0;
  box-sizing: border-box;

  .foot-c-item {
    display: flex;
    justify-content: space-between;

    ul {
      color: #888888;

      li {
        margin-bottom: 6px;

        a {
          display: block;
          color: #888;
          line-height: 22px;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }

      .introduce {
        width: 190px;
        line-height: 20px;
      }

      .foot-tel {
        color: #ff0e25;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .foot-title {
      font-size: 14px;
      color: #666666;
      margin-bottom: 8px;
    }
  }
}

.foot-b {
  width: 100%;
  background-color: #f2f2f2;

  .foot-b-item {
    height: 78px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .foot-top {
      display: flex;

      div {
        display: flex;
        align-items: center;
        a {
          color: #888888;
        }
        .line {
          height: 10px;
          width: 1px;
          // background-color: #b3b3b3;
          margin: 0 8px;
        }
      }
      div:last-child {
        .line {
          display: none;
        }
      }
    }

    .foot-bottom {
      display: flex;
      color: #bfbfbf;
      align-items: center;
      margin-top: 12px;

      li {
        margin-right: 16px;

        &:last-child {
          margin-right: 0;
        }

        position: relative;

        + li::before {
          content: '';
          width: 1px;
          height: 10px;
          background: #bfbfbf;
          position: absolute;
          top: 4px;
          left: -7px;
        }

        // &:last-child:before {
        //   display: none;
        // }
        span {
          cursor: pointer;
          transition: 0.5s;
          -moz-transition: 0.5s;
          -webkit-transition: 0.5s;
          -o-transition: 0.5s;

          &:hover {
            color: #ff0e25;
          }
        }
      }
    }
  }
}
</style>
